import PropTypes from 'prop-types';
import { jsx } from '@emotion/react';

var MAIN_PHONE = '(800) 990-9130';
var MAIN_TEL = '+1800-990-9130';

// Designer-specified colors

var SKY = '#006DFF';

var telephoneStyle = {
  pointerEvents: 'auto',
  whiteSpace: 'nowrap',
  a: {
    color: 'inherit',
    textDecoration: 'none'
  }
};
var linkStyle = {
  color: SKY,
  textDecoration: 'underline'
};
function PhoneNumber(_ref) {
  var id = _ref.id,
    phone = _ref.phone,
    tel = _ref.tel,
    isLink = _ref.isLink;
  return jsx("span", {
    css: [telephoneStyle, isLink ? linkStyle : {}, process.env.NODE_ENV === "production" ? "" : ";label:PhoneNumber;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBob25lTnVtYmVyLmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9CVSIsImZpbGUiOiJQaG9uZU51bWJlci5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IE1BSU5fUEhPTkUsIE1BSU5fVEVMIH0gZnJvbSAnLi4vLi4vLi4vaGVscGVycy9Db25zdGFudHMnO1xuaW1wb3J0IHsgU0tZIH0gZnJvbSAnLi4vLi4vLi4vc3R5bGVzL0NvbG9ycyc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuXG5jb25zdCB0ZWxlcGhvbmVTdHlsZSA9IHtcbiAgcG9pbnRlckV2ZW50czogJ2F1dG8nLFxuICB3aGl0ZVNwYWNlOiAnbm93cmFwJyxcbiAgYToge1xuICAgIGNvbG9yOiAnaW5oZXJpdCcsXG4gICAgdGV4dERlY29yYXRpb246ICdub25lJ1xuICB9XG59O1xuXG5jb25zdCBsaW5rU3R5bGUgPSB7XG4gIGNvbG9yOiBTS1ksXG4gIHRleHREZWNvcmF0aW9uOiAndW5kZXJsaW5lJ1xufTtcblxuZnVuY3Rpb24gUGhvbmVOdW1iZXIoeyBpZCwgcGhvbmUsIHRlbCwgaXNMaW5rIH0pIHtcbiAgcmV0dXJuIChcbiAgICA8c3BhbiBjc3M9e1t0ZWxlcGhvbmVTdHlsZSwgaXNMaW5rID8gbGlua1N0eWxlIDoge31dfT5cbiAgICAgIDxhIGlkPXtpZH0gaHJlZj17YHRlbDoke3RlbH1gfT5cbiAgICAgICAge3Bob25lfVxuICAgICAgPC9hPlxuICAgIDwvc3Bhbj5cbiAgKTtcbn1cblxuUGhvbmVOdW1iZXIucHJvcFR5cGVzID0ge1xuICBpZDogUHJvcFR5cGVzLnN0cmluZyxcbiAgcGhvbmU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIHRlbDogUHJvcFR5cGVzLnN0cmluZyxcbiAgaXNMaW5rOiBQcm9wVHlwZXMuYm9vbFxufTtcblxuUGhvbmVOdW1iZXIuZGVmYXVsdFByb3BzID0ge1xuICBpZDogJ21haW5QaG9uZU51bWJlcicsXG4gIHBob25lOiBNQUlOX1BIT05FLFxuICB0ZWw6IE1BSU5fVEVMXG59O1xuXG5leHBvcnQgZGVmYXVsdCBQaG9uZU51bWJlcjtcbiJdfQ== */"]
  }, jsx("a", {
    id: id,
    href: "tel:".concat(tel)
  }, phone));
}
PhoneNumber.propTypes = {
  id: PropTypes.string,
  phone: PropTypes.string,
  tel: PropTypes.string,
  isLink: PropTypes.bool
};
PhoneNumber.defaultProps = {
  id: 'mainPhoneNumber',
  phone: MAIN_PHONE,
  tel: MAIN_TEL
};

export { PhoneNumber as default };
